import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Limpar possíveis dados corrompidos do localStorage na inicialização
const cleanCorruptedStorage = () => {
  const keysToCheck = [
    'tander_auth_token',
    'tander_subscription_cache',
    'tander_user_profile_cache',
  ];

  keysToCheck.forEach(key => {
    try {
      const value = localStorage.getItem(key);
      if (value) {
        JSON.parse(value); // Tenta fazer parse para validar
      }
    } catch (error) {
      console.warn(`🧹 Removendo item corrompido: ${key}`);
      localStorage.removeItem(key);
    }
  });
};

// Executar limpeza antes de renderizar
cleanCorruptedStorage();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
